// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"muiAutoComplete_checkboxContainer__imjty","checkbox":"muiAutoComplete_checkbox__qWMxh"};